const PP_COLORS = [
  { name: 'Rosa', hex: '#dc939a' },
  { name: 'Beige', hex: '#b07e4bff' },
  { name: 'Verde Salvia', hex: '#87a39c' },
  { name: 'Azzurro', hex: '#98e2f6ff' },
  { name: 'Rosso', hex: '#D0021B' },
  { name: 'Arancione', hex: '#EC9F20' },
  { name: 'Fucsia', hex: '#E256C6' },
  { name: 'Blu', hex: '#2262aaff' },
  { name: 'Nero', hex: '#000000' },
  { name: 'Grigio', hex: '#9B9B9B' },
  { name: 'Giallo', hex: '#F8E71C' },
  { name: 'Verde', hex: '#549109ff' },
  { name: 'Lilla', hex: '#B06CEB' },
];

const PP_STORAGE_KEY = 'pp_config_v1';
const PP_CANVAS_W = 1094;
const PP_CANVAS_H = 1094;
const PP_PREVIEW_API = 'https://studioviman.it/imagedb/api/cart_preview.php';

const ppState = {
  name: ppFormatName((window.PP_CONFIG && window.PP_CONFIG.defaultName) || 'Aurora'),
  color: PP_COLORS[0],
};

function ppLoadState() {
  try {
    const raw = localStorage.getItem(PP_STORAGE_KEY);
    if (!raw) return;
    const saved = JSON.parse(raw);
    if (typeof saved.name === 'string') ppState.name = ppFormatName(saved.name);
    const color = PP_COLORS.find(c => c.hex === saved.colorHex);
    if (color) ppState.color = color;
  } catch (e) {}
}

function ppSaveState() {
  try {
    localStorage.setItem(PP_STORAGE_KEY, JSON.stringify({
      name: ppState.name,
      colorHex: ppState.color.hex,
    }));
  } catch (e) {}
}

ppLoadState();

const ppCanvas = document.getElementById('ppPreviewCanvas');
const ppCtx = ppCanvas.getContext('2d', { willReadFrequently: true });
const ppLayerCanvas = document.createElement('canvas');
ppLayerCanvas.width = PP_CANVAS_W;
ppLayerCanvas.height = PP_CANVAS_H;
const ppLayerCtx = ppLayerCanvas.getContext('2d', { willReadFrequently: true });

let ppAssetsReady = false;
let ppBackgroundImage = null;
let ppLayerPixels = null;
let ppMaskPixels = null;
let ppFontReady = false;

function ppHexToRgb(hex) {
  const clean = hex.replace('#', '');
  return {
    r: parseInt(clean.slice(0, 2), 16),
    g: parseInt(clean.slice(2, 4), 16),
    b: parseInt(clean.slice(4, 6), 16),
  };
}

function ppRgbToHsl(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      default: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }
  return { h, s, l };
}

function ppHueToRgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function ppHslToRgb(h, s, l) {
  let r;
  let g;
  let b;
  if (s === 0) {
    r = g = b = l;
  } else {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = ppHueToRgb(p, q, h + 1 / 3);
    g = ppHueToRgb(p, q, h);
    b = ppHueToRgb(p, q, h - 1 / 3);
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255),
  };
}

function ppFormatName(value) {
  return String(value || '')
    .replace(/\s+/g, ' ')
    .trimStart()
    .replace(/\S+/g, word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
}

function ppDrawColorLayer(targetHex) {
  if (!ppLayerPixels || !ppMaskPixels) return;
  const target = ppHexToRgb(targetHex);
  const targetHsl = ppRgbToHsl(target.r, target.g, target.b);
  const out = ppLayerCtx.createImageData(PP_CANVAS_W, PP_CANVAS_H);
  const src = ppLayerPixels.data;
  const mask = ppMaskPixels.data;
  const data = out.data;

  for (let i = 0; i < data.length; i += 4) {
    const maskAmount = Math.max(mask[i], mask[i + 1], mask[i + 2]) / 255;
    if (maskAmount <= 0.01) continue;

    const sourceHsl = ppRgbToHsl(src[i], src[i + 1], src[i + 2]);
    const lightness = Math.max(0.04, Math.min(0.93, targetHsl.l + (sourceHsl.l - 0.62) * 0.75));
    const saturation = Math.max(0, Math.min(1, targetHsl.s * (0.72 + sourceHsl.s * 0.42)));
    const rgb = ppHslToRgb(targetHsl.h, saturation, lightness);

    data[i] = rgb.r;
    data[i + 1] = rgb.g;
    data[i + 2] = rgb.b;
    data[i + 3] = Math.round(maskAmount * src[i + 3]);
  }

  ppLayerCtx.clearRect(0, 0, PP_CANVAS_W, PP_CANVAS_H);
  ppLayerCtx.putImageData(out, 0, 0);
  ppCtx.drawImage(ppLayerCanvas, 0, 0);
}

function ppFitFontSize(text, maxWidth, maxPx) {
  let lo = 12;
  let hi = maxPx;
  for (let i = 0; i < 24; i++) {
    const mid = (lo + hi) / 2;
    ppCtx.font = `${mid}px "Fruit Days"`;
    if (ppCtx.measureText(text).width > maxWidth) hi = mid;
    else lo = mid;
  }
  return Math.floor(lo);
}

function ppDrawName() {
  const name = ppState.name.trim();
  if (!name) return;

  const cfg = window.PP_CONFIG || {};
  const isMobile = window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
  const maxWidthPct = Number(isMobile ? cfg.nameMaxWidthPctMobile : cfg.nameMaxWidthPctDesktop) || 54;
  const maxFont = Number(isMobile ? cfg.nameMaxFontMobile : cfg.nameMaxFontDesktop) || 112;
  const maxWidth = PP_CANVAS_W * (maxWidthPct / 100);
  const fontSize = ppFitFontSize(name, maxWidth, maxFont);
  const x = PP_CANVAS_W / 2;
  const y = Number(isMobile ? cfg.nameYMobile : cfg.nameYDesktop) || 500;
  const rgb = ppHexToRgb(ppState.color.hex);
  const shadowEnabled = cfg.shadowEnabled !== false;
  const shadowOpacity = Math.max(0, Math.min(1, (Number(cfg.shadowOpacity) || 28) / 100));
  const shadowBlur = Number(cfg.shadowBlur) || 9;
  const shadowOffsetY = Number(cfg.shadowOffsetY) || 5;

  ppCtx.save();
  ppCtx.font = `${fontSize}px "Fruit Days"`;
  ppCtx.textAlign = 'center';
  ppCtx.textBaseline = 'middle';
  if (shadowEnabled) {
    ppCtx.shadowColor = `rgba(55, 42, 32, ${shadowOpacity})`;
    ppCtx.shadowBlur = shadowBlur;
    ppCtx.shadowOffsetX = 1;
    ppCtx.shadowOffsetY = shadowOffsetY;
  }
  ppCtx.fillStyle = ppState.color.hex;
  ppCtx.fillText(name, x, y);

  ppCtx.shadowColor = 'transparent';
  if (shadowEnabled) {
    ppCtx.globalAlpha = 0.16;
    ppCtx.fillStyle = 'rgba(70, 55, 40, 0.5)';
    ppCtx.fillText(name, x + 2, y + 3);
    ppCtx.globalAlpha = 1;
  }
  ppCtx.globalAlpha = 0.10;
  ppCtx.fillStyle = `rgb(${Math.min(255, rgb.r + 55)}, ${Math.min(255, rgb.g + 55)}, ${Math.min(255, rgb.b + 55)})`;
  ppCtx.fillText(name, x - 1, y - 2);
  ppCtx.restore();
}

function ppRender() {
  ppSaveState();
  if (!ppAssetsReady) return;
  ppCtx.clearRect(0, 0, PP_CANVAS_W, PP_CANVAS_H);
  ppCtx.drawImage(ppBackgroundImage, 0, 0, PP_CANVAS_W, PP_CANVAS_H);
  ppDrawColorLayer(ppState.color.hex);
  ppDrawName();
}

async function ppInitFont() {
  const assets = window.PP_ASSETS || {};
  try {
    if (assets.fruitDaysOtf && 'FontFace' in window) {
      const face = new FontFace('Fruit Days', `url(${assets.fruitDaysOtf})`);
      await face.load();
      document.fonts.add(face);
    }
    await document.fonts.load('80px "Fruit Days"');
  } catch (e) {}
  ppFontReady = true;
}

function ppLoadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

function ppImageToPixels(img) {
  const offscreen = document.createElement('canvas');
  offscreen.width = PP_CANVAS_W;
  offscreen.height = PP_CANVAS_H;
  const octx = offscreen.getContext('2d', { willReadFrequently: true });
  octx.drawImage(img, 0, 0, PP_CANVAS_W, PP_CANVAS_H);
  return octx.getImageData(0, 0, PP_CANVAS_W, PP_CANVAS_H);
}

async function ppInitImages() {
  const assets = window.PP_ASSETS || {};
  try {
    const [background, layer, mask] = await Promise.all([
      ppLoadImage(assets.backgroundImage),
      ppLoadImage(assets.colorLayerImage),
      ppLoadImage(assets.maskImage),
    ]);
    ppBackgroundImage = background;
    ppLayerPixels = ppImageToPixels(layer);
    ppMaskPixels = ppImageToPixels(mask);
    ppAssetsReady = true;
    document.getElementById('ppPreviewLoading').classList.add('hidden');
    ppRender();
  } catch (e) {
    document.getElementById('ppPreviewLoading').textContent = 'Anteprima non disponibile';
  }
}

function ppBuildColorSwatches() {
  const container = document.getElementById('ppColorSwatches');
  const label = document.getElementById('ppColorLabel');
  container.innerHTML = '';

  PP_COLORS.forEach(color => {
    const swatch = document.createElement('button');
    swatch.type = 'button';
    swatch.className = 'pp-color-swatch' + (ppState.color.hex === color.hex ? ' active' : '');
    swatch.style.background = color.hex;
    swatch.dataset.hex = color.hex;
    swatch.title = color.name;
    swatch.setAttribute('aria-label', color.name);
    swatch.addEventListener('click', () => {
      ppState.color = color;
      label.textContent = color.name;
      container.querySelectorAll('.pp-color-swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
      ppUpdatePriceDisplay();
      ppRender();
    });
    container.appendChild(swatch);
  });
}

function ppFindVariant() {
  try {
    const optionNames = Array.isArray(window.PP_OPTION_NAMES) ? window.PP_OPTION_NAMES : [];
    const variants = Array.isArray(window.PP_VARIANTS) ? window.PP_VARIANTS : [];
    const colorIndex = optionNames.map(n => String(n).toLowerCase()).findIndex(n => n.includes('colore'));
    const wanted = ppState.color.name.toLowerCase();
    return variants.find(v => {
      const options = (v.options || []).map(o => String(o).toLowerCase());
      return colorIndex < 0 ? options.includes(wanted) : options[colorIndex] === wanted;
    }) || null;
  } catch (e) {
    return null;
  }
}

function ppFindVariantId() {
  const variant = ppFindVariant();
  return variant ? variant.id : null;
}

function ppUpdatePriceDisplay() {
  const variant = ppFindVariant();
  if (!variant) return;

  const priceCurrent = document.getElementById('ppPriceCurrent');
  const priceAmount = document.getElementById('ppPriceAmount');
  if (!priceCurrent || !priceAmount) return;

  priceCurrent.textContent = variant.priceMoney || '';

  const oldCompare = priceAmount.querySelector('.pp-price-compare');
  if (oldCompare) oldCompare.remove();

  if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
    const compare = document.createElement('span');
    compare.className = 'pp-price-compare';
    compare.textContent = variant.compareAtPriceMoney || '';
    priceAmount.insertBefore(compare, priceCurrent);
  }
}

function ppGeneratePreviewThumbnail() {
  try {
    const width = 480;
    const height = Math.round(width * PP_CANVAS_H / PP_CANVAS_W);
    const thumb = document.createElement('canvas');
    thumb.width = width;
    thumb.height = height;
    const tctx = thumb.getContext('2d');
    tctx.fillStyle = '#ffffff';
    tctx.fillRect(0, 0, width, height);
    tctx.drawImage(ppCanvas, 0, 0, width, height);
    return thumb.toDataURL('image/jpeg', 0.76);
  } catch (e) {
    return null;
  }
}

async function ppUploadPreviewImage(dataUrl) {
  try {
    const res = await fetch(PP_PREVIEW_API, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ image: dataUrl }),
    });
    if (!res.ok) return null;
    const json = await res.json();
    return json && json.url ? json.url : null;
  } catch (e) {
    return null;
  }
}

function ppShowToast(message) {
  alert(message);
}

function ppSetupForm() {
  const form = document.getElementById('ppAddToCartForm');
  form.addEventListener('submit', async event => {
    event.preventDefault();

    const name = ppState.name.trim();
    if (!name) {
      ppShowToast('Inserisci il nome prima di procedere.');
      document.getElementById('ppNameInput').focus();
      return;
    }

    const button = form.querySelector('.pp-btn-primary');
    const originalText = button.textContent;
    button.textContent = 'Aggiunta in corso...';
    button.disabled = true;

    try {
      ppRender();
      const properties = {
        'Nome': name,
        'Colore': ppState.color.name,
      };

      const preview = ppGeneratePreviewThumbnail();
      if (preview) {
        const uploaded = await ppUploadPreviewImage(preview);
        properties._preview = uploaded || preview;
      }

      const variantId = ppFindVariantId() || parseInt(form.querySelector('input[name="id"]').value, 10);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties,
          }],
        }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Errore aggiunta al carrello');
      }

      window.location.href = '/cart';
    } catch (err) {
      ppShowToast(err.message || 'Qualcosa è andato storto.');
      button.textContent = originalText;
      button.disabled = false;
    }
  });
}

function ppSetupInputs() {
  const input = document.getElementById('ppNameInput');
  const label = document.getElementById('ppColorLabel');
  input.value = ppState.name;
  label.textContent = ppState.color.name;

  input.addEventListener('input', event => {
    const caret = event.target.selectionStart;
    ppState.name = ppFormatName(event.target.value);
    event.target.value = ppState.name;
    try { event.target.setSelectionRange(caret, caret); } catch (e) {}
    ppRender();
  });
}

function ppSetupMiniPreview() {
  const root = document.getElementById('preview-portapenne-root');
  if (!root) return;

  const stage = root.querySelector('.pp-preview-stage');
  const mini = document.getElementById('ppPreviewMini');
  const miniCanvas = document.getElementById('ppPreviewMiniCanvas');
  const unstick = document.getElementById('ppPreviewUnstick');
  if (!stage || !mini || !miniCanvas) return;

  const miniCtx = miniCanvas.getContext('2d');
  const mq = window.matchMedia('(max-width: 900px)');
  const topGap = 10;
  const miniHeight = 118;
  const releaseAt = topGap + miniHeight + 30;
  const hyst = 80;
  let shown = false;
  let scrolledPast = false;
  let pastControls = false;
  let rafMirror = null;

  function startMirror() {
    if (rafMirror) return;
    (function loop() {
      try {
        miniCtx.drawImage(ppCanvas, 0, 0, miniCanvas.width, miniCanvas.height);
      } catch (e) {}
      rafMirror = window.requestAnimationFrame(loop);
    })();
  }

  function stopMirror() {
    if (rafMirror) window.cancelAnimationFrame(rafMirror);
    rafMirror = null;
  }

  function show() {
    if (shown) return;
    mini.classList.add('show');
    shown = true;
    startMirror();
  }

  function hide() {
    if (!shown) return;
    mini.classList.remove('show');
    shown = false;
    stopMirror();
  }

  function update() {
    if (!mq.matches) {
      hide();
      return;
    }
    const stageTop = stage.getBoundingClientRect().top;
    const unlockBottom = unstick ? unstick.getBoundingClientRect().bottom : Infinity;

    if (!scrolledPast && stageTop <= topGap) scrolledPast = true;
    else if (scrolledPast && stageTop > topGap + hyst) scrolledPast = false;

    if (!pastControls && unlockBottom <= releaseAt) pastControls = true;
    else if (pastControls && unlockBottom > releaseAt + hyst) pastControls = false;

    if (scrolledPast && !pastControls) show();
    else hide();
  }

  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', () => { hide(); update(); });
  update();
}

function ppSetupGallery() {
  const images = Array.isArray(window.PP_GALLERY_IMAGES)
    ? window.PP_GALLERY_IMAGES.filter(img => img && img.thumb && img.full)
    : [];
  const box = document.getElementById('ppGalleryBox');
  const grid = document.getElementById('ppGalleryGrid');
  const prev = document.getElementById('ppGalleryPrev');
  const next = document.getElementById('ppGalleryNext');
  const lightbox = document.getElementById('ppGalleryLightbox');
  const lightboxImg = document.getElementById('ppGalleryLightboxImg');
  const close = document.getElementById('ppGalleryLightboxClose');
  const lbPrev = document.getElementById('ppGalleryLightboxPrev');
  const lbNext = document.getElementById('ppGalleryLightboxNext');
  if (!box || !grid || !lightbox || !lightboxImg) return;

  if (!images.length) {
    box.classList.remove('is-visible');
    return;
  }

  let index = 0;
  box.classList.add('is-visible');
  grid.innerHTML = images.map((img, i) => `
    <button class="pp-gallery-thumb" type="button" data-index="${i}" aria-label="Apri foto ${i + 1}">
      <img src="${img.thumb}" alt="${img.alt || ''}" width="360" height="360" loading="lazy">
    </button>
  `).join('');

  function updateArrows() {
    if (!prev || !next) return;
    const overflow = grid.scrollWidth - grid.clientWidth > 4;
    prev.style.display = overflow ? 'flex' : 'none';
    next.style.display = overflow ? 'flex' : 'none';
    prev.disabled = grid.scrollLeft <= 4;
    next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
  }

  function showLightboxAt(nextIndex) {
    index = (nextIndex + images.length) % images.length;
    const img = images[index];
    lightboxImg.src = img.full;
    lightboxImg.alt = img.alt || '';
    const multiple = images.length > 1;
    if (lbPrev) lbPrev.disabled = !multiple;
    if (lbNext) lbNext.disabled = !multiple;
  }

  function openLightbox(nextIndex) {
    showLightboxAt(nextIndex);
    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden', 'false');
  }

  function closeLightbox() {
    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden', 'true');
  }

  grid.querySelectorAll('.pp-gallery-thumb').forEach(button => {
    button.addEventListener('click', () => openLightbox(parseInt(button.dataset.index, 10)));
  });

  if (prev) prev.addEventListener('click', () => grid.scrollBy({ left: -Math.max(grid.clientWidth * 0.8, 120), behavior: 'smooth' }));
  if (next) next.addEventListener('click', () => grid.scrollBy({ left: Math.max(grid.clientWidth * 0.8, 120), behavior: 'smooth' }));
  grid.addEventListener('scroll', () => window.requestAnimationFrame(updateArrows), { passive: true });
  window.addEventListener('resize', updateArrows, { passive: true });

  close.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', event => {
    if (event.target === lightbox) closeLightbox();
  });
  if (lbPrev) lbPrev.addEventListener('click', event => {
    event.stopPropagation();
    showLightboxAt(index - 1);
  });
  if (lbNext) lbNext.addEventListener('click', event => {
    event.stopPropagation();
    showLightboxAt(index + 1);
  });

  document.addEventListener('keydown', event => {
    if (!lightbox.classList.contains('open')) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') showLightboxAt(index - 1);
    if (event.key === 'ArrowRight') showLightboxAt(index + 1);
  });

  let touchX = 0;
  lightbox.addEventListener('touchstart', event => {
    touchX = event.changedTouches[0].clientX;
  }, { passive: true });
  lightbox.addEventListener('touchend', event => {
    const dx = event.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) < 45 || images.length < 2) return;
    showLightboxAt(dx > 0 ? index - 1 : index + 1);
  }, { passive: true });

  updateArrows();
}

(async function ppInit() {
  ppSetupInputs();
  ppBuildColorSwatches();
  ppUpdatePriceDisplay();
  ppSetupForm();
  ppSetupMiniPreview();
  ppSetupGallery();
  await ppInitFont();
  await ppInitImages();
})();
